
















import Vue from "vue";

export default Vue.extend({
  name: "Startpage",
  mounted() {
    Vue.set(this.$root.$data, "title", "Startpage");
  },
  computed: {
    text(): string {
      return this.$root.$data.user
        ? "Welcome to Pii Masker!"
        : "Please log in.";
    },
    user(): any {
      return this.$root.$data.user;
    }
  }
});
